import React from "react";

const SearchNotFound = () => {
    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <p style={{textAlign:'center'}}>Aspirasi tidak ditemukan.</p>
                </div>
            </div>
        </div>
    );
}

export default SearchNotFound;